import React from 'react';
//import swiper react components
import {Swiper, SwiperSlide} from 'swiper/react';
//import swiper styles
import 'swiper/css';
import 'swiper/css/effect-fade';
//import requared modules
import { EffectFade, Autoplay } from 'swiper';
//images
import DCImg3 from '../assets/img/room.jpg';
import DREAMImg1 from '../assets/img/roomS.jpg';

import { useTranslation } from 'react-i18next';

const slides = [
  {
    title: 'Dream Apartments & DC Executive Homes',
    bg: DCImg3,
  },
  {
    title: 'Dream Apartments & DC Executive Homes',
    bg: DREAMImg1,
  },
  // {
  //   title: 'Dream Apartments & DC Executive Homes',
  //   bg: DCImg3,
  // },
];

const scrollToSection = (sectionId) => {
  const section = document.getElementById(sectionId);

  if (section) {
    section.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  }
};

const HeroSlider = () => {
  const [t, i18n] = useTranslation("global");
  return (
 <Swiper modules={[EffectFade, Autoplay]} 
  effect={'fade'}
  loop={true}
  autoplay={{
    delay: 3000,
    disableOnInteraction: false,
  }}
  className='heroSlider h-[600px] lg:h-[860px]'>
  {slides.map((slide, index) => {
    //destructure slide bg-pink-400
    const {title, bg } = slide;
    return (
    <SwiperSlide className='h-full relative flex justify-center items-center' key={index}>
      <div className='z-20 text-white text-center'>
        <div className='uppercase font-tertiary tracking-[6px] mb-5'>Enjoy & Relax</div>
        <h1 className='text-[32px] font-primary uppercase tracking-[2px] max-w-[920px] lg:text-[68px] leading-tight mb-6 w-[90%] md:w-full mx-auto'>{title}</h1>
        <button className='btn btn-lg btn-primary mx-auto w-[80%] sm:w-auto text-[14px] sm:text-[15px]'
        onClick={() => scrollToSection('sobeTarget')}>{t("homeT.dugmeText")}</button>
      </div>
      <div className='absolute top-0 w-full h-full'>
        <img className='object-cover h-full w-full' src={bg} ald='' />
      </div>
      {/* overlay */}
      <div className='absolute w-full h-full bg-black/70'></div>
    </SwiperSlide>
    );
  })}
 </Swiper>
  );
};

export default HeroSlider;
